/**
 * Labstep
 *
 * @module core/Loader
 * @desc Wrapper around semantic-ui-react Loader
 */

import type React from 'react';
import SemanticLoader, {
  type StrictLoaderProps,
} from 'semantic-ui-react/dist/commonjs/elements/Loader';

export const Loader: React.FC<StrictLoaderProps> = (props) => (
  <SemanticLoader {...props} />
);
